import { useEffect, useState } from "react";
import { http, fmtINR } from "@/lib/api";

const TYPE_STYLES = {
    BXGY: "bg-purple-500/10 text-purple-600 border-purple-500/30",
    Qty: "bg-blue-500/10 text-blue-600 border-blue-500/30",
    Value: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30",
    Bundle: "bg-amber-500/10 text-amber-600 border-amber-500/30",
    Tiered: "bg-rose-500/10 text-rose-600 border-rose-500/30",
};

export default function Schemes() {
    const [schemes, setSchemes] = useState([]);
    useEffect(() => {
        http.get("/schemes").then((r) => setSchemes(r.data));
    }, []);

    return (
        <div className="mx-auto max-w-[1560px] space-y-4 p-6">
            <div className="flex items-end justify-between">
                <div>
                    <div className="mlabel">Schemes</div>
                    <h1 className="text-[22px] font-semibold tracking-tight">Trade & Consumer Schemes</h1>
                </div>
                <div className="text-[11px] text-muted-foreground">{schemes.length} active</div>
            </div>

            <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3" data-testid="schemes-grid">
                {schemes.map((s) => {
                    const claimedPct = s.accrued > 0 ? (s.claimed / s.accrued) * 100 : 0;
                    return (
                        <div
                            key={s.id}
                            data-testid={`scheme-${s.id}`}
                            className="hover-lift flex flex-col gap-3 rounded-sm border border-border bg-card p-4"
                        >
                            <div className="flex items-start justify-between">
                                <div>
                                    <div className="text-sm font-semibold">{s.name}</div>
                                    <div className="mono-num text-[11px] text-muted-foreground">{s.code}</div>
                                </div>
                                <span
                                    className={
                                        "rounded-sm border px-1.5 py-[1px] text-[10px] font-medium " +
                                        (TYPE_STYLES[s.scheme_type] || "")
                                    }
                                >
                                    {s.scheme_type}
                                </span>
                            </div>
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <div className="mlabel">Audience</div>
                                    <div className="text-[13px] font-medium capitalize">{s.audience}</div>
                                </div>
                                <div>
                                    <div className="mlabel">Window</div>
                                    <div className="mono-num text-[11px]">
                                        {s.start_date?.slice(0, 10)} → {s.end_date?.slice(0, 10)}
                                    </div>
                                </div>
                            </div>
                            <div className="space-y-1">
                                <div className="flex justify-between text-[11px] text-muted-foreground">
                                    <span>Accrued</span>
                                    <span className="mono-num text-foreground">{fmtINR(s.accrued)}</span>
                                </div>
                                <div className="flex justify-between text-[11px] text-muted-foreground">
                                    <span>Claimed</span>
                                    <span className="mono-num text-foreground">{fmtINR(s.claimed)}</span>
                                </div>
                                <div className="h-1.5 overflow-hidden rounded-full bg-border">
                                    <div
                                        className="h-full bg-primary"
                                        style={{ width: `${Math.min(100, claimedPct)}%` }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
